import React from "react";

import "./Statutes.scss";
import Modal from "../Global/Modal";
import { useState } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

const useStyles = makeStyles(_ => ({
  root: {
      maxWidth: '80%',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 20
  },
}));

const StatutesPage: React.FC = () => {
  const [customExport, setCustomExport] = useState(false);
  const closeModal = () => {
    setCustomExport(false);
  };
  const classes = useStyles();
  useDocumentTitle("Golden Record Statutes");
  return (
    <Grid container direction='column' className={`${classes.root} flex-gap-2`}>
      {customExport && (
        <Modal onClose={closeModal} header="Custom Export">
          <div style={{ display: "flex", borderBottom: "1px solid grey", margin: "1rem", paddingBottom: "1rem" }}>
            <div style={{ flex: "0 0 25%" }}>
              <div style={{ fontWeight: "bold" }}>Title</div>
              <select id="title" className="m-xsmall-top-1">
                <option value="1">Title 1</option>
                <option value="2">Title 2</option>
              </select>
            </div>
            <div style={{ flex: "0 0 25%" }}>
              <div style={{ fontWeight: "bold" }}>Article</div>
              <select id="article" className="m-xsmall-top-1" disabled>
                <option value="1">-</option>
              </select>
            </div>
            <div style={{ flex: "0 0 25%" }}>
              <div style={{ fontWeight: "bold" }}>Section</div>
              <select id="article" className="m-xsmall-top-1" disabled>
                <option value="1">-</option>
              </select>
            </div>
            <div style={{ flex: "0 0 25%" }}>
              <div style={{ fontWeight: "bold" }}>Component(s)</div>
              <br />
              <input type="checkbox" name="comp1" />
              <label htmlFor="comp1">Section Content</label>
              <br />
              <input type="checkbox" />
              <label htmlFor="comp2">Footnote</label>
              <br />
              <input type="checkbox" />
              <label htmlFor="comp3">Editor's Note</label>
              <br />
              <input type="checkbox" />
              <label htmlFor="comp4">Annotations</label>
            </div>
          </div>
          <div style={{ display: "flex", borderBottom: "1px solid grey", margin: "1rem", paddingBottom: "1rem" }}>
            <button className="button default medium">Add to Export</button>
          </div>
          <div style={{ display: "flex", margin: "1rem" }}>
            <button className="button default primary medium">Create Export</button>&nbsp;
            <button className="button default danger medium">Cancel</button>
          </div>
        </Modal>
      )}
      <Typography variant='h1'>Golden Record Statutes</Typography>
      <div className="statutes-container">
        <div className="statutes-container__col1">
          <div style={{ boxShadow: "2px 2px 5px #d9d9d9", padding: "1rem" }}>
            <div style={{ backgroundColor: "#d9d9d9", width: "550px", fontSize: "2rem" }}>&nbsp;</div>

            <div className="m-xsmall-top-2" style={{ backgroundColor: "#d9d9d9", width: "300px", fontSize: "1.5rem" }}>
              &nbsp;
            </div>

            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "300px", fontSize: "1.5rem" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "500px", fontSize: "1.5rem" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-2" style={{ backgroundColor: "#d9d9d9", width: "300px", fontSize: "1.5rem" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "500px", fontSize: "1.5rem" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "300px", fontSize: "1.5rem" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "300px", fontSize: "1.5rem" }}>
              &nbsp;
            </div>
            <div className="m-xsmall-top-1" style={{ backgroundColor: "#d9d9d9", width: "500px", fontSize: "1.5rem" }}>
              &nbsp;
            </div>
            <div
              className="m-xsmall-top-1 m-xsmall-bottom-2"
              style={{ backgroundColor: "#d9d9d9", width: "250px", fontSize: "1.5rem" }}
            >
              &nbsp;
            </div>
          </div>
        </div>
        <div className="statutes-container__col2">
          <div className="statutes__col2-row1">
            <button className="button primary default medium print-button">Print Document</button>
          </div>
          <div className="statutes__col2-row2">
            <div className="font-primary" style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
              Export Options
            </div>

            <div className="font-secondary m-xsmall-top-1">Export Format</div>
            <div style={{ marginTop: "0.5rem", fontSize: "0.9rem", lineHeight: "1.2rem" }}>
              Use the dropdown below to select your desired export format
            </div>

            <select id="format" className="m-xsmall-top-1" style={{ width: "100%" }}>
              <option value="pdf">PDF</option>
              <option value="xml">XML</option>
            </select>

            <div className="font-secondary m-xsmall-top-1">Export Statutes</div>
            <div style={{ marginTop: "0.5rem", fontSize: "0.9rem", lineHeight: "1.2rem" }}>
              Click the button below to export all of the statutes
            </div>

            <button className="button default medium print-button m-xsmall-top-1">Export Statutes</button>

            <div className="font-secondary m-xsmall-top-1">Export Title</div>
            <select id="title" className="m-xsmall-top-1" style={{ width: "100%" }}>
              <option value="1">Title 1</option>
              <option value="2">Title 2</option>
            </select>
            <div style={{ marginTop: "0.5rem", fontSize: "0.9rem", lineHeight: "1.2rem" }}>
              Click the button below to export the selected title in the format of your choosing
            </div>
            <button className="button default medium print-button m-xsmall-top-1">Export Title</button>

            <div className="font-secondary m-xsmall-top-1">Custom Export</div>
            <div style={{ marginTop: "0.5rem", fontSize: "0.9rem", lineHeight: "1.2rem" }}>
              Click the button below to open the custom export tool
            </div>
            <button className="button default medium print-button m-xsmall-top-1" onClick={() => setCustomExport(true)}>
              Custom Export
            </button>
          </div>
        </div>
      </div>
    </Grid>
  );
};

export default StatutesPage;
